<!-- Test Component HTML -->
<div class="bg-destructive text-center font-body text-xl"><p>Test</p></div>

<!-- HERO -->
<!-- overflow-hidden, sticky'i engelliyor. -->
<section class="relative pt-10 pb-12 px-4 bg-background">
    <div #contentGrid class="absolute inset-0 bg-grid-pattern opacity-15 z-0"></div>
    <!-- <div class="absolute bottom-[-10%] -left-[5%] w-[500px] h-[500px] bg-accent/15 rounded-full blur-[100px] opacity-20 z-0"></div> -->

    <div class="container mx-auto relative z-10 max-w-8xl">
        <div class="flex flex-col lg:flex-row gap-12">

            <!-- Content Column -->
            <div class="w-full lg:w-2/3 flex flex-col items-start gap-4 py-10 lg:py-20">
                <div class="inline-flex items-center gap-2 px-3 py-1 rounded-full bg-primary/10 border border-primary/20 text-primary text-sm font-medium">
                    <span class="relative flex h-2 w-2">
                        <span class="animate-ping absolute inline-flex h-full w-full rounded-full bg-primary opacity-75"></span>
                        <span class="relative inline-flex rounded-full h-2 w-2 bg-primary"></span>
                    </span>
                    Let's Work Together !
                </div>

                <h1 class="text-5xl md:text-6xl lg:text-7xl font-display font-bold leading-[1.1] tracking-tight text-foreground">
                    Burakhan Şamlı<br />
                    <span class="text-transparent bg-clip-text bg-gradient-to-r from-primary via-purple-400 to-accent animate-gradient">
                        Computer Vision & NLP
                    </span><br />
                    AI Specialist
                </h1>
                <div class="prose prose-slate sm:prose-sm md:prose-base lg:prose-lg xl:prose-xl text-muted-foreground max-w-2xl leading-relaxed font-body mb-0">
                    &nbsp;&nbsp;I am a Forensic Informatics Engineer with a strong interest in image processing, <strong>computer vision</strong>,
                    and GIS-based <strong>remote sensing</strong>, focused on developing practical and scalable AI-driven solutions.
                    My background includes work on biometric and identity-related systems such as <strong>facial recognition</strong> and
                    image-based identification, as well as <strong>object detection</strong>, <strong>segmentation</strong>, and <strong>tracking</strong> tasks.
                    In parallel with computer vision, I actively work with Transformer-based architectures in both vision and <strong>NLP</strong> domains,
                    aiming to stay aligned with current advances in deep learning.
                    I have experience applying these models to tasks such as image enhancement, representation learning, and
                    text-based analysis, and I continuously explore emerging methods and architectures to strengthen my understanding
                    of modern AI systems.
                </div>
                <div class="prose prose-slate sm:prose-sm md:prose-base lg:prose-lg xl:prose-xl text-muted-foreground max-w-2xl leading-relaxed font-body mt-0">
                    &nbsp;&nbsp;I have also worked on satellite image analysis and GIS-focused projects, particularly involving
                    <strong>multispectral</strong> and <strong>hyperspectral</strong> data for agriculture-oriented &nbsp;applications
                    such as land use and land cover (LULC) analysis. Across my projects, I integrate machine learning models into deployable
                    software systems, working with containerized and <strong>microservice-based</strong> architectures using tools
                    such as <strong>Docker</strong> and <strong>Kubernetes</strong>, and remain motivated to learn, adapt, and contribute
                    to real-world projects where data-driven solutions create measurable impact.
                </div>

                <div class="flex flex-col sm:flex-row items-center gap-6 mt-4 w-full sm:w-auto">
                    <a routerLink="/projects" class="group w-full sm:w-auto">
                        <button class="relative w-full sm:w-auto flex items-center justify-center gap-3 text-lg font-display font-medium px-8 py-4 rounded-xl 
									 bg-primary text-primary-foreground 
									 shadow-[0_10px_20px_-10px_rgba(var(--primary),0.5)]
									 transition-all duration-300 
									 hover:shadow-[0_20px_30px_-10px_rgba(var(--primary),0.6)]
									 hover:-translate-y-1 active:scale-95
									 cursor-pointer">
                            <span>View Projects</span>
                            <span class="transition-transform duration-300 group-hover:translate-x-2">
                                <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round">
                                    <path d="M5 12h14m-7-7 7 7-7 7" />
                                </svg>
                            </span>
                            <div class="absolute inset-0 rounded-xl bg-white/10 opacity-0 group-hover:opacity-100 transition-opacity pointer-events-none"></div>
                        </button>
                    </a>

                    <a routerLink="/blog" class="group w-full sm:w-auto">
                        <button class="relative w-full sm:w-auto flex items-center justify-center gap-3 text-lg font-display font-medium px-8 py-4 rounded-xl 
									 border-2 border-border bg-background/50 backdrop-blur-sm text-foreground
									 transition-all duration-300 
									 hover:border-primary/50 hover:bg-primary/5
									 hover:-translate-y-1 active:scale-95
									 cursor-pointer">
                            <span class="transition-transform duration-300 group-hover:-rotate-12">
                                <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                                    <path d="M4 19.5v-15A2.5 2.5 0 0 1 6.5 2H20v20H6.5a2.5 2.5 0 0 1-2.5-2.5Z" />
                                    <path d="M8 7h6" />
                                    <path d="M8 11h8" />
                                </svg>
                            </span>
                            <span>Read Articles</span>
                            <div class="absolute bottom-2 left-8 right-8 h-[1px] bg-primary scale-x-0 group-hover:scale-x-100 transition-transform duration-300"></div>
                        </button>
                    </a>

                </div>
            </div>
            
            <!-- Fingerprint Column - Sticky (Desktop only) -->
            <div class="hidden lg:block lg:w-1/3 py-20">
                <div class="sticky top-24">
                    <div class="flex items-center justify-center relative">
                        <div class="size-72 bg-gradient-to-br from-primary/30 to-accent/30 rounded-full blur-[90px] absolute animate-pulse"></div>
                        <div class="relative z-10 p-8 rounded-3xl bg-white/5 border border-white/10 backdrop-blur-2xl shadow-2xl flex items-center justify-center overflow-hidden group">
                            <div class="absolute inset-0 bg-primary/10 opacity-0 group-hover:opacity-100 transition-opacity duration-500"></div>

                            <lucide-icon [img]="FingerprintPatternIcon" class="size-48 text-primary opacity-90 relative z-10 transition-transform duration-700 group-hover:scale-110"></lucide-icon>

                            <div class="absolute top-2 left-2 size-4 border-t-2 border-l-2 border-primary/30"></div>
                            <div class="absolute bottom-2 right-2 size-4 border-b-2 border-r-2 border-primary/30"></div>
                        </div>
                    </div>
                </div>
            </div>

        </div>
    </div>
</section>



<div class="bg-accent text-center font-body text-xl"><p>Non Sticky</p></div>

<!-- HERO -->
<section class="relative min-h-[90vh] flex items-center pt-10 pb-12 px-4 overflow-hidden bg-background">

    <div class="absolute inset-0 bg-grid-pattern opacity-10 z-0"></div>
    <div class="absolute bottom-[-10%] -left-[5%] w-[500px] h-[500px] bg-accent/15 rounded-full blur-[100px] opacity-20 z-0"></div>

    <div class="container mx-auto relative z-10 max-w-8xl">
        <div class="grid grid-cols-1 lg:grid-cols-12 gap-12 items-center">

            <!-- Content -->
            <div class="lg:col-span-8 flex flex-col items-start gap-4">
                <div class="inline-flex items-center gap-2 px-3 py-1 rounded-full bg-primary/10 border border-primary/20 text-primary text-sm font-medium">
                    <span class="relative flex h-2 w-2">
                        <span class="animate-ping absolute inline-flex h-full w-full rounded-full bg-primary opacity-75"></span>
                        <span class="relative inline-flex rounded-full h-2 w-2 bg-primary"></span>
                    </span>
                    Let's Work Together !
                </div>

                <h1 class="text-5xl md:text-6xl lg:text-7xl font-display font-bold leading-[1.1] tracking-tight text-foreground">
                    Burakhan Şamlı<br />
                    <span class="text-transparent bg-clip-text bg-gradient-to-r from-primary via-purple-400 to-accent animate-gradient">
                        Computer Vision & NLP
                    </span><br />
                    AI Specialist
                </h1>
                <div class="prose prose-slate sm:prose-sm md:prose-base lg:prose-lg xl:prose-xl text-muted-foreground max-w-2xl leading-relaxed font-body mb-0">
                    &nbsp;&nbsp;I am a Forensic Informatics Engineer with a strong interest in image processing, <strong>computer vision</strong>,
                    and GIS-based <strong>remote sensing</strong>, focused on developing practical and scalable AI-driven solutions.
                    My background includes work on biometric and identity-related systems such as <strong>facial recognition</strong> and
                    image-based identification, as well as <strong>object detection</strong>, <strong>segmentation</strong>, and <strong>tracking</strong> tasks.
                    In parallel with computer vision, I actively work with Transformer-based architectures in both vision and <strong>NLP</strong> domains,
                    aiming to stay aligned with current advances in deep learning.
                    I have experience applying these models to tasks such as image enhancement, representation learning, and
                    text-based analysis, and I continuously explore emerging methods and architectures to strengthen my understanding
                    of modern AI systems.
                </div>
                <div class="prose prose-slate sm:prose-sm md:prose-base lg:prose-lg xl:prose-xl text-muted-foreground max-w-2xl leading-relaxed font-body mt-0">
                    &nbsp;&nbsp;I have also worked on satellite image analysis and GIS-focused projects, particularly involving
                    <strong>multispectral</strong> and <strong>hyperspectral</strong> data for agriculture-oriented &nbsp;applications
                    such as land use and land cover (LULC) analysis. Across my projects, I integrate machine learning models into deployable
                    software systems, working with containerized and <strong>microservice-based</strong> architectures using tools
                    such as <strong>Docker</strong> and <strong>Kubernetes</strong>, and remain motivated to learn, adapt, and contribute
                    to real-world projects where data-driven solutions create measurable impact.
                </div>

                <div class="flex flex-col sm:flex-row items-center gap-6 mt-4 w-full sm:w-auto">
                    <a routerLink="/projects" class="group w-full sm:w-auto">
                        <button class="relative w-full sm:w-auto flex items-center justify-center gap-3 text-lg font-display font-medium px-8 py-4 rounded-xl 
									 bg-primary text-primary-foreground 
									 shadow-[0_10px_20px_-10px_rgba(var(--primary),0.5)]
									 transition-all duration-300 
									 hover:shadow-[0_20px_30px_-10px_rgba(var(--primary),0.6)]
									 hover:-translate-y-1 active:scale-95
									 cursor-pointer">
                            <span>View Projects</span>
                            <span class="transition-transform duration-300 group-hover:translate-x-2">
                                <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round">
                                    <path d="M5 12h14m-7-7 7 7-7 7" />
                                </svg>
                            </span>
                            <div class="absolute inset-0 rounded-xl bg-white/10 opacity-0 group-hover:opacity-100 transition-opacity pointer-events-none"></div>
                        </button>
                    </a>

                    <a routerLink="/blog" class="group w-full sm:w-auto">
                        <button class="relative w-full sm:w-auto flex items-center justify-center gap-3 text-lg font-display font-medium px-8 py-4 rounded-xl 
									 border-2 border-border bg-background/50 backdrop-blur-sm text-foreground
									 transition-all duration-300 
									 hover:border-primary/50 hover:bg-primary/5
									 hover:-translate-y-1 active:scale-95
									 cursor-pointer">
                            <span class="transition-transform duration-300 group-hover:-rotate-12">
                                <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                                    <path d="M4 19.5v-15A2.5 2.5 0 0 1 6.5 2H20v20H6.5a2.5 2.5 0 0 1-2.5-2.5Z" />
                                    <path d="M8 7h6" />
                                    <path d="M8 11h8" />
                                </svg>
                            </span>
                            <span>Read Articles</span>
                            <div class="absolute bottom-2 left-8 right-8 h-[1px] bg-primary scale-x-0 group-hover:scale-x-100 transition-transform duration-300"></div>
                        </button>
                    </a>

                </div>
            </div>
            
            <!-- Fingerprint -->
            <div class="hidden lg:col-span-4 lg:flex items-center justify-center relative">
                <div class="size-72 bg-gradient-to-br from-primary/30 to-accent/30 rounded-full blur-[90px] absolute animate-pulse"></div>
                <div class="relative z-10 p-8 rounded-3xl bg-white/5 border border-white/10 backdrop-blur-2xl shadow-2xl flex items-center justify-center overflow-hidden group">
                    <div class="absolute inset-0 bg-primary/10 opacity-0 group-hover:opacity-100 transition-opacity duration-500"></div>

                    <lucide-icon [img]="FingerprintPatternIcon" class="size-48 text-primary opacity-90 relative z-10 transition-transform duration-700 group-hover:scale-110"></lucide-icon>

                    <div class="absolute top-2 left-2 size-4 border-t-2 border-l-2 border-primary/30"></div>
                    <div class="absolute bottom-2 right-2 size-4 border-b-2 border-r-2 border-primary/30"></div>
                </div>

            </div>

        </div>
    </div>
</section>